/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrowserInfoDto
 */
export interface BrowserInfoDto {
    /**
     * 
     * @type {string}
     * @memberof BrowserInfoDto
     */
    userAgent?: string;
    /**
     * 
     * @type {number}
     * @memberof BrowserInfoDto
     */
    colorDepth?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BrowserInfoDto
     */
    javaEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BrowserInfoDto
     */
    language?: string;
    /**
     * 
     * @type {number}
     * @memberof BrowserInfoDto
     */
    screenHeight?: number;
    /**
     * 
     * @type {number}
     * @memberof BrowserInfoDto
     */
    screenWidth?: number;
    /**
     * 
     * @type {number}
     * @memberof BrowserInfoDto
     */
    timeZoneOffset?: number;
    /**
     * 
     * @type {string}
     * @memberof BrowserInfoDto
     */
    acceptHeader?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrowserInfoDto
     */
    javaScriptEnabled?: boolean;
}

/**
 * Check if a given object implements the BrowserInfoDto interface.
 */
export function instanceOfBrowserInfoDto(value: object): value is BrowserInfoDto {
    return true;
}

export function BrowserInfoDtoFromJSON(json: any): BrowserInfoDto {
    return BrowserInfoDtoFromJSONTyped(json, false);
}

export function BrowserInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrowserInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userAgent': json['userAgent'] == null ? undefined : json['userAgent'],
        'colorDepth': json['colorDepth'] == null ? undefined : json['colorDepth'],
        'javaEnabled': json['javaEnabled'] == null ? undefined : json['javaEnabled'],
        'language': json['language'] == null ? undefined : json['language'],
        'screenHeight': json['screenHeight'] == null ? undefined : json['screenHeight'],
        'screenWidth': json['screenWidth'] == null ? undefined : json['screenWidth'],
        'timeZoneOffset': json['timeZoneOffset'] == null ? undefined : json['timeZoneOffset'],
        'acceptHeader': json['acceptHeader'] == null ? undefined : json['acceptHeader'],
        'javaScriptEnabled': json['javaScriptEnabled'] == null ? undefined : json['javaScriptEnabled'],
    };
}

export function BrowserInfoDtoToJSON(json: any): BrowserInfoDto {
    return BrowserInfoDtoToJSONTyped(json, false);
}

export function BrowserInfoDtoToJSONTyped(value?: BrowserInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userAgent': value['userAgent'],
        'colorDepth': value['colorDepth'],
        'javaEnabled': value['javaEnabled'],
        'language': value['language'],
        'screenHeight': value['screenHeight'],
        'screenWidth': value['screenWidth'],
        'timeZoneOffset': value['timeZoneOffset'],
        'acceptHeader': value['acceptHeader'],
        'javaScriptEnabled': value['javaScriptEnabled'],
    };
}

